module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Arrow-up-05ee066d5b14d1660d5e66f091679af0.svg";